import styled from "styled-components";

export const Svg = styled.svg`
  display: inline-block;
  vertical-align: middle;
`;

export type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>;
